import p4Icon from '@images/spe-low-level-programming/P4.png';
import dpdkIcon from '@images/spe-low-level-programming/dpdk.svg';
import { fpga as fpgaIcon } from '@images/logos-techstack';
import smartnicIcon from '@images/spe-low-level-programming/smartnic.svg';

export const experience = [
  {
    title: 'DPDK',
    icon: dpdkIcon,
    sectionId: 'spe-dpdk',
  },
  {
    title: 'SmartNIC',
    icon: smartnicIcon,
    sectionId: 'spe-smartnic',
  },
  {
    title: 'P4',
    icon: p4Icon,
    sectionId: 'spe-p4',
  },
  {
    title: 'FPGA',
    icon: fpgaIcon,
    sectionId: 'spe-fpga',
  },
];
